/**
 * Pure gift-card display helpers used by OrdersDetailController (summary.tpl.html's
 * gift-cards table). Extracted out of the controller because AngularJS controllers
 * have no test harness in this codebase ($controller/angular-mocks isn't used anywhere
 * here) — see ApplicationController.spec.ts for the same pattern applied to
 * addGiftCardsNavItemIfEnabled.
 */

/**
 * Binary on ISSUED (Q7): every other status — known or future — fails closed to Inactive.
 * Do not enumerate the red cases; only ISSUED is ever active.
 */
export function isGiftCardActive(status: string | undefined | null): boolean {
  return status === 'ISSUED';
}

/**
 * Checks if a gift card is in a stuck state that can be retried via activation.
 * These are transient error states where the issuance failed but can be retried.
 */
export function isGiftCardStuck(status: string | undefined | null): boolean {
  return status === 'PENDING_ISSUE' || status === 'ERRORED_ACTIVATION';
}

export function getGiftCardStatusLabel(status: string | undefined | null): string {
  return isGiftCardActive(status) ? 'Active' : 'Inactive';
}

export function getGiftCardStatusBadgeClass(status: string | undefined | null): string {
  return isGiftCardActive(status) ? 'badge-outline-success' : 'badge-outline-danger';
}

/**
 * Title-cases the backend's uppercase giftCardType ("PHYSICAL"/"DIGITAL") for display.
 */
export function getGiftCardTypeLabel(giftCardType: string | undefined | null): string {
  if (!giftCardType) {
    return '';
  }
  return giftCardType.charAt(0).toUpperCase() + giftCardType.slice(1).toLowerCase();
}

/**
 * Card Number column: only the last four are ever available (no PIN/full number stored).
 */
export function getGiftCardMaskedNumber(lastFour: string | undefined | null): string {
  return '••••' + (lastFour || '');
}
